import {Vue} from 'ui.vue';


import './BXmakerAuthuserphoneCaptcha.styl';
import './BXmakerAuthuserphoneLoader';
import './BXmakerAuthuserphoneInput';
import './BXmakerAuthuserphoneRefresh';

/**
 * @emits onRefresh {} - ���� �� ������ ���������� �����
 * @emits onComplete {} - ����� ������ ������ Enter ��� ����� ������� ��������� ���������� ��������
 * @emits onInput {string} - ���� ����
 */
Vue.component('BXmakerAuthuserphoneCaptcha',
    {
        props: {
            code: {
                type: [String, Boolean],
                default: false,
            },
            src: {
                type: [String, Boolean],
                default: false,
            },
            length: {
                type: [Boolean, Number],
                default: 5,
            },
            loader: {
                type: [Boolean],
                default: false,
            }
        },
        data: function () {
            return {};
        },
        computed: {
            localize() {
                return BX.Vue.getFilteredPhrases('BXMAKER_AUTHUSERPHONE_CORE_CAPTCHA_');
            },
        },
        methods: {
            onEnter() {
                this.$emit('onComplete');
            },
            onInput(value) {
                this.$emit('onInput', value);

                if (value.length === this.length) {
                    this.onEnter();
                }
            },
        },
        template: `
            <div class="bxmaker-authuserphone-captcha" :class="{'bxmaker-authuserphone-captcha--loading' : loader}"  v-if="src"  >
                 
                 <div class="bxmaker-authuserphone-captcha__img ">
                    <BXmakerAuthuserphoneRefresh @onClick="$emit('onRefresh')" />
                    <BXmakerAuthuserphoneLoader v-if="loader" />  
                    <img :src="src"  />                             
                 </div>    
                              
                 <div class="bxmaker-authuserphone-captcha__input">
                       <BXmakerAuthuserphoneInput  :title="localize.BXMAKER_AUTHUSERPHONE_CORE_CAPTCHA_INPUT_TITLE"                        
                       :value="code" 
                       :maxLength="length"
                       @onInput="onInput"
                       @onEnter="onEnter"
                       />            
                </div>
                
            </div>
        `,
    });